import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class GestcuotaService extends ApiService {
  constructor(private http: Http) {
    super('api/gestcuotas/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/gestcuota.service.ts